import type { Howl } from 'howler';
import { getGameSoundConfig, type CasinoGameKey } from '@/constants/game-settings';
import { createSound } from '@/utils/sound';

export const createGameSound = (game: CasinoGameKey, soundKey: string): Howl | null => {
	const config = getGameSoundConfig(game, soundKey);
	if (!config) {
		return null;
	}

	const { src, volume } = config;
	return createSound(src, volume);
};
